import React from 'react';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import { FaLinkedinIn} from 'react-icons/fa';
const SocialMeadia = () => {
  return (
    <div className="app__social">
    <div>
    <a href="https://twitter.com/_masoomraza_"  target="_blank"><BsTwitter /></a> 
    </div>
    <div>
      <a href="https://www.linkedin.com/in/masumrazacse/"  target="_blank"><FaLinkedinIn /></a>
    </div>
    <div>
     <a href="https://www.instagram.com/_masoomraza_/"  target="_blank"><BsInstagram /></a> 
    </div>
  </div>
  )
}

export default SocialMeadia